import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { FadeUp, Overline } from "../components/Reveal";

const sections = [
  {
    title: "Introduction",
    body: "Vincen (\u201cwe\u201d, \u201cus\u201d, \u201cour\u201d) is a luxury maison of collectable dress. This Privacy Policy explains how we collect, use, and protect the personal information you share with us when you browse our collections, create an account, or place an order.",
  },
  {
    title: "Information We Collect",
    body: "We collect the details you provide directly \u2014 your name, email address, shipping address, and order history. When you sign in, we store a secure session token. We do not store card numbers; payment is handled through our demo checkout and no live payment is processed.",
  },
  {
    title: "How We Use Your Information",
    body: "Your information allows us to fulfil orders, maintain your account, respond to enquiries through our concierge, and keep you informed about your purchases. We use it only to serve you \u2014 never to intrude.",
  },
  {
    title: "Cookies & Sessions",
    body: "We use essential cookies to keep you signed in and to remember your preferences, such as your chosen light or dark theme. These cookies are necessary for the house to function and are never sold.",
  },
  {
    title: "Sharing & Disclosure",
    body: "We do not sell your personal information. We share it only with trusted services required to operate the maison \u2014 such as our hosting and email providers \u2014 and only to the extent necessary to serve you.",
  },
  {
    title: "Your Rights",
    body: "You may access, export, or permanently delete your account and associated data at any time from the Data Privacy area of your account. If you would prefer we handle this for you, reach us at the address below.",
  },
  {
    title: "Contact",
    body: "For any question regarding your privacy, write to us at vinceninfo@gmail.com and a member of the house will attend to you.",
  },
];

const PrivacyPolicy = () => {
  return (
    <div data-testid="privacy-policy-page" className="min-h-screen pt-28 md:pt-36 pb-28">
      <div className="max-w-[900px] mx-auto px-6 md:px-12">
        <Link
          to="/"
          data-testid="privacy-back-link"
          className="inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-zinc-500 hover:text-gold transition-colors duration-300"
        >
          <ArrowLeft size={13} /> The House
        </Link>

        <FadeUp>
          <div className="mt-10">
            <Overline>Information</Overline>
            <h1 className="mt-4 font-serif text-4xl md:text-6xl font-light text-[#F5F5F5] leading-tight">
              Privacy Policy
            </h1>
            <p className="mt-6 text-xs tracking-[0.3em] uppercase text-zinc-500">
              Last updated &mdash; June 2026
            </p>
          </div>
        </FadeUp>

        <div className="mt-16 flex flex-col gap-12">
          {sections.map((s, i) => (
            <FadeUp key={s.title} delay={0.05}>
              <div
                data-testid={`privacy-section-${i}`}
                className="border-t border-white/10 pt-8"
              >
                <h2 className="font-serif text-2xl md:text-3xl font-light text-[#F5F5F5]">
                  {s.title}
                </h2>
                <p className="mt-4 text-sm md:text-base text-zinc-400 leading-relaxed">
                  {s.body}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
